export const projectsName = {
  firstName: 'Project Name',

  secondName: 'Project Name',
};

export const portfolioText =
  'Once the house has been granted a completion certificate by the council and approved by your agent, you can lie back on your carefully chosen sofa and admire your wonderful new home. The defects period - where the contractor is obliged to make good any snags - will normally last 12 months.';
